export enum CarouselViewType {
    EXTERIOR = 'Exterior',
    INTERIOR = 'Interior',
}

export enum ImageViewType {
    INTERIOR = 'Int',
    EXTERIOR = 'Ext',
}
